'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetScrollStuff = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHandlerBound = false;
var scrollCallbacks = [];
var timeout = void 0;
var lastId = 0;
var scrollHandler = function scrollHandler() {
  clearTimeout(timeout);
  timeout = setTimeout(function () {
    scrollCallbacks.forEach(function (_ref2) {
      var fn = _ref2.fn;
      return fn();
    });
  }, 50);
};
var CALLBACKS = {
  ON_ENTER: 'onDwellEnter',
  ON_LEAVE: 'onDwellLeave',
  ON_DWELL: 'onDwell'
};

var resetScrollStuff = void 0; // eslint-disable-line import/no-mutable-exports
if (__TEST__) {
  exports.resetScrollStuff = resetScrollStuff = function resetScrollStuff() {
    scrollCallbacks.length = 0;
    scrollHandlerBound = false;
    window.removeEventListener('scroll', scrollHandler, true);
    window.removeEventListener('resize', scrollHandler, true);
  };
}
exports.resetScrollStuff = resetScrollStuff;

exports.default = function (Component) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref$dwellTime = _ref.dwellTime,
      dwellTime = _ref$dwellTime === undefined ? 1000 : _ref$dwellTime,
      callbacks = (0, _objectWithoutProperties3.default)(_ref, ['dwellTime']);

  var klass = function (_React$Component) {
    (0, _inherits3.default)(klass, _React$Component);

    function klass() {
      var _ref3;

      var _temp, _this, _this3, _ret;

      (0, _classCallCheck3.default)(this, klass);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = _this = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = klass.__proto__ || (0, _getPrototypeOf2.default)(klass)).call.apply(_ref3, [this].concat(args))), _this3), _this3.onDwellScroll = function () {
        if (_this.inViewport()) {
          if (_this.wasInViewport !== true) {
            _this.triggerCallback(CALLBACKS.ON_ENTER);
          }
          if (!_this.dwellTimeout && !_this.wasInViewport) {
            _this.dwellTimeout = setTimeout(function () {
              _this.dwellTimeout = null;
              if (_this.inViewport()) {
                _this.triggerCallback(CALLBACKS.ON_DWELL);
              }
            }, dwellTime);
          }
          _this.wasInViewport = true;
        } else if (!_this.inViewport() && _this.wasInViewport !== false) {
          _this.triggerCallback(CALLBACKS.ON_LEAVE);
          _this.wasInViewport = false;
        }
      }, _this3.setComponentNode = function (cmp) {
        return _this.componentNode = cmp;
      }, _this3.inViewport = function () {
        if (_this.componentNode) {
          // eslint-disable-next-line react/no-find-dom-node
          var node = _reactDom2.default.findDOMNode(_this.componentNode);

          if (!node) {
            return false;
          }

          var rect = node.getBoundingClientRect();

          // This implementation will trigger if at least one pixel of the element is in the viewport
          return rect.bottom > 0 && rect.right > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight) && rect.left < (window.innerWidth || document.documentElement.clientWidth);
        }
      }, _this3.triggerCallback = function (callbackName) {
        if (callbacks[callbackName]) {
          callbacks[callbackName]();
        }
        if (_this.componentNode && _this.componentNode[callbackName]) {
          _this.componentNode[callbackName]();
        }
      }, _temp), (0, _possibleConstructorReturn3.default)(_this3, _ret);
    }

    (0, _createClass3.default)(klass, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!scrollHandlerBound) {
          scrollHandlerBound = true;
          window.addEventListener('scroll', scrollHandler, true);
          window.addEventListener('resize', scrollHandler, true);
        }
        scrollCallbacks.push({
          id: lastId += 1,
          fn: this.onDwellScroll
        });
        this.dwellScrollbackId = scrollCallbacks[scrollCallbacks.length - 1].id;
        this.wasInViewport = null;
        this.onDwellScroll();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this2 = this;

        scrollCallbacks = scrollCallbacks.filter(function (_ref4) {
          var id = _ref4.id;
          return id !== _this2.dwellScrollbackId;
        });

        if (scrollCallbacks.length === 0) {
          window.removeEventListener('scroll', scrollHandler, true);
          window.removeEventListener('resize', scrollHandler, true);
          scrollHandlerBound = false;
        }
      }

      /* istanbul ignore next */

    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, (0, _extends3.default)({
          ref: this.setComponentNode
        }, this.props));
      }
    }]);
    return klass;
  }(_react2.default.Component);

  klass.displayName = 'fiveEyes(' + (Component.displayName || Component.name) + ')';

  return (0, _hoistNonReactStatics2.default)(klass, Component);
};